import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { motion } from 'framer-motion';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import ChartHeader from '../../charts/ChartHeader';
import {
  RanchAreaEnum,
  selectRanchFocusArea,
  setRanchFocusArea,
} from '../ranchesSlice';

interface Props {
  gridArea: RanchAreaEnum;
}

const RanchAreaHeader_Deprecated: React.FC<Props> = ({ gridArea }) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const focusedArea = useAppSelector(selectRanchFocusArea);

  const iconStyles: SxProps = {
    color: theme.colors.common.white,
  };

  const handleFocusAreaClick = (
    e: React.MouseEvent<HTMLElement>,
    gridArea: RanchAreaEnum
  ) => {
    if (focusedArea !== null) {
      dispatch(setRanchFocusArea(null));
    } else {
      dispatch(setRanchFocusArea(gridArea));
    }
  };

  return (
    <motion.div
      layout
      style={{
        width: '100%',
        height: '3.5rem',
        borderTopLeftRadius: theme.borderRadius.primary,
        borderTopRightRadius: theme.borderRadius.primary,
        padding: '0.25rem',
        backgroundColor: theme.colors.darkTheme.grey.medium,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <motion.div
        layout
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {gridArea === RanchAreaEnum.chartArea && <ChartHeader />}
      </motion.div>
      <motion.div
        layout
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <IconButton
          aria-label='FullScreen Toggle'
          size='small'
          onClick={(e) => handleFocusAreaClick(e, gridArea)}
        >
          {focusedArea === gridArea ? (
            <FullscreenExitIcon sx={{ ...iconStyles }} />
          ) : (
            <FullscreenIcon sx={{ ...iconStyles }} />
          )}
        </IconButton>
      </motion.div>
    </motion.div>
  );
};

export default RanchAreaHeader_Deprecated;
